export enum TAG_TYPES {
    SeatingPlanCategoryTag = 'SeatingPlanCategoryTag',
    EventTag = 'EventTag',
    OrganizerTag = 'OrganizerTag',
}
